import './App.css';
import "./intercepter";
import {Navigate, Route, Routes } from 'react-router-dom';
import PublicRoutes from "./components/Routes/PublicRoutes";
import ProtectedRoutes from "./components/Routes/ProtectedRoutes";
import Login from './components/Login/Login';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import Competency from './components/Competency/Competency';
import User from './components/User/User';
import Profile from './components/Profile/Profile';
import Security from './components/Security/Security';
import Subjects from './components/Subjects/Subjects';
import Assessments from './components/Assessments/Assessments';
import AddQuestion from './components/Competency/AddQuestion';
import SurveyTemplates from './components/SurveyTemplates/SurveyTemplate';
import Survey from './components/Survey/Survey';
import Reports from './components/Reports/Reports';
import ReportPdf from './components/Reports/Pdf';
import Team from './components/Team/Team';
import CreateAssessment from './components/Assessments/CreateAssessment';
import AssessmentSample from './components/Survey/AssessmentSample';
import ReportView from './components/Reports/ReportView';
import SurveyWelcome from './components/Survey/SurveyWelcome';
import AssessmentSampleWelcome from './components/Survey/AssessmentSampleWelcome';
import EmailTemplate from './components/EmailTemplate/EmailTemplate';
import AddEmailTemplate from './components/EmailTemplate/AddEmailTemplate';
import ViewEmailTemplate from './components/EmailTemplate/ViewEmailTemplate';
import ReportViewOpenEnded from './components/Reports/ReportViewOpenEnded';
import CompetencyLibraries from './components/Competency/CompetencyLibraries';

function App() {
  return (
    <Routes>
      
      <Route path="/survey/welcome/:usrData" element={<SurveyWelcome />}></Route>
      <Route path="/survey/:usrData" element={<Survey />}></Route>
      <Route path="/assessment-sample/welcome/:usrData" element={<AssessmentSampleWelcome />}></Route>
      <Route path="/assessment-sample/:usrData" element={<AssessmentSample />}></Route>
      
      <Route path="/" element={<PublicRoutes />}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot_password" element={<ForgotPassword />}></Route>
      </Route>
      
      <Route path="/" element={<ProtectedRoutes />}>
        <Route path="/" element={<Navigate replace to="admins" />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/admins" element={<User />}></Route>
        <Route path="/email_templates" element={<EmailTemplate />}></Route>
        <Route path="/add_email_template" element={<AddEmailTemplate />}></Route>
        <Route path="/edit_email_template/:templateId" element={<AddEmailTemplate />}></Route>
        <Route path="/view_email_template/:templateId" element={<ViewEmailTemplate />}></Route>
        <Route path="/competencies" element={<Competency />}></Route>
        <Route path="/profile" element={<Profile />}></Route>
        <Route path="/security" element={<Security />}></Route>
        <Route path="/organizations" element={<Team />}></Route>
        <Route path="/subjects" element={<Subjects />}></Route>
        <Route path="/assessments" element={<Assessments />}></Route>
        <Route path="/create_assessment" element={<CreateAssessment />}></Route>
        <Route path="/create_assessment/:assessmentId" element={<CreateAssessment />}></Route>
        <Route path="/add_questions/:competencyId" element={<AddQuestion />}></Route>
        <Route path="/add_questions/:competencyId/:userId" element={<AddQuestion />}></Route>
        <Route path="/survey_templates" element={<SurveyTemplates />}></Route>
        <Route path="/reports" element={<Reports />}></Route>
        {/* <Route path="/report_pdf/:subjectId" element={<ReportPdf />}></Route> */}
        <Route path="/report_view/:subjectId" element={<ReportView />}></Route>
        <Route path="/report_view_open_ended/:subjectId" element={<ReportViewOpenEnded />}></Route>
        <Route path="/competency_libraries" element={<CompetencyLibraries />}></Route>
      </Route>
      
    </Routes>
  );
}

export default App;
